'use client';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

const settings = {
	infinite: true,
	speed: 1500,
	slidesToShow: 1,
	slidesToScroll: 1,
	autoplay: true,
	arrows: false,
};

// Slider errors when included in a server-rendered component so we have this client component instead
export const TextMarqueeSlider = ({ children }) =>
	<Slider {...settings}>
		{children}
	</Slider>
